// extracted by css-extract-rspack-plugin
export default {"paper":"MARDialog_paper__ncYnu"};